// extracted by mini-css-extract-plugin
module.exports = {"threejscanvas":"globals-module--threejscanvas--5S09z","landingPageContent":"globals-module--landingPageContent--1BwkS","notFoundPane":"globals-module--notFoundPane--is3nY"};